import { useState } from "react";
import { Container, Nav, Navbar, NavDropdown } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import { isDevelopment } from "../config";
import { useAuth } from "../contexts/AuthContext";

export default function TopNav() {
  const { user, logout } = useAuth();
  const location = useLocation();
  const [expanded, setExpanded] = useState(false);

  return (
    <Navbar
      bg={isDevelopment ? "warning" : "dark"}
      variant={isDevelopment ? "light" : "dark"}
      expand="lg"
      expanded={expanded}
      onToggle={setExpanded}
      className={isDevelopment ? "dev-environment" : ""}
    >
      <Container fluid>
        <Navbar.Brand as={Link} to="/" onClick={() => setExpanded(false)}>
          Campaign Manager
          {isDevelopment && <span className="badge bg-danger ms-2">DEV</span>}
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto">
            <Nav.Link
              as={Link}
              to="/map"
              active={location.pathname === "/map"}
              onClick={() => setExpanded(false)}
            >
              Map
            </Nav.Link>
            <Nav.Link
              as={Link}
              to="/dashboard"
              active={location.pathname === "/dashboard"}
              onClick={() => setExpanded(false)}
            >
              Dashboard
            </Nav.Link>
            <Nav.Link
              as={Link}
              to="/assignments"
              active={location.pathname.startsWith("/assignments")}
              onClick={() => setExpanded(false)}
            >
              Assignments
            </Nav.Link>
            <Nav.Link
              as={Link}
              to="/find-my-friends"
              active={location.pathname === "/find-my-friends"}
              onClick={() => setExpanded(false)}
            >
              Find My Friends
            </Nav.Link>
            {(user?.role === "admin" || user?.role === "postcard_writer") && (
              <Nav.Link
                as={Link}
                to="/postcard"
                active={location.pathname.startsWith("/postcard")}
                onClick={() => setExpanded(false)}
              >
                Postcards
              </Nav.Link>
            )}
            {user?.role === "admin" && (
              <NavDropdown
                title="Admin"
                id="admin-nav-dropdown"
                active={location.pathname.startsWith("/admin")}
              >
                <NavDropdown.Item
                  as={Link}
                  to="/admin/user-management"
                  onClick={() => setExpanded(false)}
                >
                  User Management
                </NavDropdown.Item>
                <NavDropdown.Item
                  as={Link}
                  to="/admin/search"
                  onClick={() => setExpanded(false)}
                >
                  Address Search
                </NavDropdown.Item>
                <NavDropdown.Item
                  as={Link}
                  to="/admin/assignments"
                  onClick={() => setExpanded(false)}
                >
                  Manage Assignments
                </NavDropdown.Item>
                <NavDropdown.Item
                  as={Link}
                  to="/admin/cut-turf"
                  onClick={() => setExpanded(false)}
                >
                  Cut Turf
                </NavDropdown.Item>
                <NavDropdown.Item
                  as={Link}
                  to="/admin/contacts"
                  onClick={() => setExpanded(false)}
                >
                  Upload Early Voting
                </NavDropdown.Item>
                <NavDropdown.Item
                  as={Link}
                  to="/admin/tags"
                  onClick={() => setExpanded(false)}
                >
                  Tag Management
                </NavDropdown.Item>
                <NavDropdown.Item
                  as={Link}
                  to="/admin/activity-log"
                  onClick={() => setExpanded(false)}
                >
                  Activity Log
                </NavDropdown.Item>
                <NavDropdown.Divider />
                <NavDropdown.Item
                  as={Link}
                  to="/admin/postcard-management"
                  onClick={() => setExpanded(false)}
                >
                  Postcard Management
                </NavDropdown.Item>
                <NavDropdown.Item
                  as={Link}
                  to="/admin/donors"
                  onClick={() => setExpanded(false)}
                >
                  Donors
                </NavDropdown.Item>
                <NavDropdown.Item
                  as={Link}
                  to="/admin/donors/map"
                  onClick={() => setExpanded(false)}
                >
                  Donor Map
                </NavDropdown.Item>
              </NavDropdown>
            )}
          </Nav>
          <Nav>
            <NavDropdown
              title={`${user?.firstName || user?.email} (${user?.role})`}
              id="user-nav-dropdown"
              align="end"
            >
              <NavDropdown.Item
                as={Link}
                to="/settings"
                onClick={() => setExpanded(false)}
              >
                Settings
              </NavDropdown.Item>
              <NavDropdown.Divider />
              <NavDropdown.Item
                onClick={() => {
                  setExpanded(false);
                  logout();
                }}
              >
                Sign Out
              </NavDropdown.Item>
            </NavDropdown>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}
